module.exports = __webpack_public_path__ + "img/plan1-min.da74e473.png";